import { useTranslation } from 'react-i18next'
import { AppLocale, changeAppLanguage } from '../i18n'

type LanguageSwitchProps = {
  /** Light text on dark hero header vs dark text on light booking header */
  variant?: 'light' | 'dark'
}

export function LanguageSwitch({ variant = 'dark' }: LanguageSwitchProps) {
  const { t, i18n } = useTranslation('common')
  const active = (i18n.language?.startsWith('id') ? 'id' : 'en') as AppLocale

  const setLocale = (locale: AppLocale) => {
    if (locale === active) return
    void changeAppLanguage(locale)
  }

  const base =
    variant === 'light'
      ? 'text-white/70 hover:text-white'
      : 'text-gray-500 hover:text-gray-900'
  const activeCls =
    variant === 'light'
      ? 'font-semibold text-white'
      : 'font-semibold text-gray-900'
  const divider = variant === 'light' ? 'text-white/40' : 'text-gray-300'

  return (
    <div
      className="inline-flex items-center gap-1 text-xs font-medium tracking-wide"
      role="group"
      aria-label={t('language')}
    >
      <button
        type="button"
        className={`rounded px-1.5 py-0.5 transition-colors ${active === 'en' ? activeCls : base}`}
        aria-pressed={active === 'en'}
        onClick={() => setLocale('en')}
      >
        {t('langEn')}
      </button>
      <span className={divider} aria-hidden>
        |
      </span>
      <button
        type="button"
        className={`rounded px-1.5 py-0.5 transition-colors ${active === 'id' ? activeCls : base}`}
        aria-pressed={active === 'id'}
        onClick={() => setLocale('id')}
      >
        {t('langId')}
      </button>
    </div>
  )
}
